var _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtoRikaTristes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -14.35,
    y: -39.95,
    rx: 0,
    ry: 0,
    width: 28.7,
    height: 79.9,
    transform: "matrix(.68 0 0 .68 137.749 313.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -14.35,
    y: -39.95,
    rx: 0,
    ry: 0,
    width: 28.7,
    height: 79.9,
    transform: "matrix(.68 0 0 .68 167.397 313.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -20.55,
    y: -17.1,
    rx: 0,
    ry: 0,
    width: 41.1,
    height: 34.2,
    transform: "matrix(.68 0 0 .68 153.117 275.748)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -12.15,
    y: -8.55,
    rx: 0,
    ry: 0,
    width: 24.3,
    height: 17.1,
    transform: "matrix(.68 0 0 .68 152.573 156.85)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M210.5 239.6c0 1.5-6.5 2.7-14.6 2.7s-14.6-1.2-14.6-2.7v161h30.1l-.9-161z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -15.8,
    y: -38.1,
    rx: 0,
    ry: 0,
    width: 31.6,
    height: 76.2,
    transform: "matrix(.68 0 0 .68 138.055 363.128)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M158.8 575.8c-.1 0-.1 0 0 0-4.6 0-8.3 3.7-8.3 8.3h39.9v-8.3h-31.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -15.8,
    y: -38.1,
    rx: 0,
    ry: 0,
    width: 31.6,
    height: 76.2,
    transform: "rotate(180 83.576 181.578) scale(.68)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M233.2 575.8c4.6 0 8.3 3.7 8.3 8.3h-39.9v-8.3h31.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#282727",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -24.05,
    y: -5.9,
    rx: 0,
    ry: 0,
    width: 48.1,
    height: 11.8,
    transform: "matrix(.68 0 0 .68 152.709 264.936)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#c5c3c8",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 7.8,
    ry: 5.9,
    transform: "matrix(.68 0 0 .68 152.675 264.936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M239.7 278.9 254.5 445h-46.4V239.7h22.7c2.9 0 5.8.5 8.4 1.5l.5 37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.32 -4.004)",
    d: "M208.1 238.8v50.6l14.9-26.7-6.4-8 9.1-2.9 1-13h-18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.01)",
    d: "M141.7 179.3c-1.9-.1-3.7.3-5.5 1.1-7.2 3.3-9.6 13.2-5.5 22.2 3.6 7.8 10.9 12.2 17.5 11.1l-6.5-34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#82220f",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.32 -4.004)",
    d: "M204.5 70.7c0-.7-2.2-18.8 3.4-30.2 0 0 5.5 7.4 7.5 30.3 0 0-2.9 6.7-3.4 6.7-.5.1-7.5-6.8-7.5-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#82220f",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M226.9 66.8c.5-.2 9.9-13.5 20.7-18.3 0 0 1.2 12.9-11.5 27.2l-7.9 5.7s-4.3-11-3.9-11.8c.4-.8 2.6-2.8 2.6-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#551400",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M201.2 83.1s-11-11.7-12.9-37.5c0 0 15.6 10.5 21.1 24 0 0 4.3-23 23.3-46.1 0 0 2.7 20.2-2.9 49.9 0 0 12.7-12.9 25.7-17 0 0-5.5 22.6-21.9 33.4l-25.5-1.5-6.9-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M229.2 99.4 203 92.7c-3.4-.9-5.4-4.3-4.6-7.7.9-3.4 4.3-5.4 7.7-4.6l26.2 6.7c3.4.9 5.4 4.3 4.6 7.7-.9 3.5-4.3 5.5-7.7 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#551400",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.01)",
    d: "M150.3 106.5s46.9-31.2 87.4-3.8c0 0 40.4 21.9 14.7 79.8l-33.2 6.5-68.9-82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.01)",
    d: "M250.1 179.3c1.9-.1 3.7.3 5.5 1.1 7.2 3.3 9.6 13.2 5.5 22.2-3.6 7.8-10.9 12.2-17.5 11.1l6.5-34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m229.9 116.8-1.1 2.2-14.4 7-21.2-6.7s-1.9-3.5-3.9-7.3h-8.7c-21.4 0-38.8 17.4-38.8 38.8v42.9c0 21.4 17.4 38.8 38.8 38.8h30.9c21.4 0 38.8-17.4 38.8-38.8v-42.9c-.2-14.6-8.3-27.4-20.4-34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#82220f",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M214.4 126.1s40.8-9.9 33.9 54.1c0 0 13.4-22.3 8.9-50.7 0 0-6.2-17.5-21.9-16.1 0 0-17.5 0-20.9 12.7zM155.2 176.1v.4c0 9.9 4.6 17.9 10.2 17.9s10.2-8 10.2-17.9v-.4h-20.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 4.2,
    ry: 7.3,
    transform: "matrix(.68 0 0 .68 134.79 118.872)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#82220f",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 10.2,
    ry: 17.9,
    transform: "matrix(.68 0 0 .68 173.483 116.016)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#551400",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -3.997)",
    d: "M218.4 165.8s16-8 26.5 3.1c0 0-18.9-21.2-26.5-3.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 4.2,
    ry: 7.3,
    transform: "matrix(.68 0 0 .68 176.475 111.8)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f08372",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M177.7 216.6c2.9-1 5.8-1.8 8.8-2.5 1.5-.4 3-.6 4.4-1l4.5-.8c3-.5 6-1 9-1.3 3-.3 6-.6 9.1-.7-2.9 1-5.8 1.7-8.8 2.4-2.9.7-5.9 1.3-8.9 1.8l-4.5.7-4.5.6c-3 .5-6.1.7-9.1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#551400",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M147.1 176.1h28.5s-.6-10.3-28.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M152.3 278.9 137.5 445h46.4V239.7h-22.7c-2.9 0-5.8.5-8.4 1.5l-.5 37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "M183.9 238.8v50.6L169 262.6l6.4-8-9.1-2.9-1-13c0 .1 19 .1 18.6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m227.8 338-.7-40.4-.1-7.8-.7-37.5c-.1-6.8 4.5-12.5 10.3-12.6 5.8-.1 10.6 5.4 10.7 12.2l.7 37.5.1 7.8.7 38.4-21 2.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -0.7,
    y: -27.45,
    rx: 0,
    ry: 0,
    width: 1.4,
    height: 54.9,
    transform: "translate(173.816 196.004) scale(.68)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m250.1 326.9-4.3-14.4-9-30.4-1.9-6.3-1.3-4.3-19.6 7.9.7 2.4 1.9 6.3 1.7 5.7.7 2.4 1.9 6.3 9 30.4c1.6 5.6 7.5 8.7 13 7.1 5.7-1.7 8.8-7.5 7.2-13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0cfd0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m233.6 271.5 1.3 4.3 1.9 6.3 7.6 25.5 1.1-.3-7.6-25.6-1.9-6.3-1.3-4.3-.4-1.2-1.2.5-19.6 7.9-1 .4.3 1 .7 2.4 1.9 6.3 1.7 5.7.7 2.4 1.9 6.3 9 30.4c1.5 4.9 6.1 8.3 11.2 8.3 1.1 0 2.2-.2 3.3-.5.6-.2 1.2-.4 1.7-.7l-.1-1.3c-.6.3-1.3.6-2 .8-1 .3-2 .4-3 .4-4.5 0-8.7-3-10.1-7.5l-9-30.4-1.9-6.3-.7-2.4-1.7-5.7-1.9-6.3-.7-2.4 19.8-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.01)",
    d: "m155.2 338.4 4.9-40.1.9-7.7 4.5-37.2c.8-6.8-3.2-12.9-8.9-13.6-5.8-.7-11.1 4.2-11.9 11l-4.5 37.2-.9 7.7-4.6 38.1 20.5 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e6e6e6",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.32 -4.004)",
    d: "m185 320.5-2.5.2-6.6.5-31.6 2.3c-5.8.4-10.1 5.4-9.7 11.2.4 5.8 5.4 10.1 11.2 9.7l31.6-2.3 6.6-.5 4.5-.3-3.5-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.01)",
    d: "m232.5 316.8-38.7 2.8 3.5 20.8 36.8-2.7c5.8-.4 10.1-5.4 9.7-11.2-.5-5.8-5.5-10.1-11.3-9.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -12.9,
    y: -7.65,
    rx: 0,
    ry: 0,
    width: 25.8,
    height: 15.3,
    transform: "rotate(-94 177.934 39.468) scale(.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -27.45,
    y: -0.7,
    rx: 0,
    ry: 0,
    width: 54.9,
    height: 1.4,
    transform: "rotate(-83.1 175.208 26.134) scale(.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -15.5,
    y: -0.7,
    rx: 0,
    ry: 0,
    width: 31,
    height: 1.4,
    transform: "translate(136.076 214.616) scale(.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -20.5,
    y: -0.7,
    rx: 0,
    ry: 0,
    width: 41,
    height: 1.4,
    transform: "translate(132.819 228.978) scale(.68)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m200.4 234.5 11 37.2 19.6-7.9-10.5-35.3c-1.6-5.6-7.5-8.7-13-7.1-5.6 1.7-8.7 7.6-7.1 13.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#d0d0d0",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -12.9,
    y: -7.65,
    rx: 0,
    ry: 0,
    width: 25.8,
    height: 15.3,
    transform: "rotate(163.7 72.084 101.9) scale(.68)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.327 -4.004)",
    d: "m231 263.9-19.6 7.9m-.9-50.8c4.5 0 8.7 3 10.1 7.5l.8 2.7 1.1-.4-.8-2.6c-1.5-4.9-6.1-8.3-11.2-8.3-1.1 0-2.2.2-3.3.5-5.4 1.6-8.7 6.7-8.3 12.1l1.2.1c-.5-4.9 2.6-9.6 7.5-11 .9-.4 1.9-.6 2.9-.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e22921",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.68 0 0 .68 19.334 -4.004)",
    d: "M214.4 126.1S108.9 92.9 152 254.6c0 0-42.5-41.1-31.2-115.8 0-.1 10-75.1 93.6-12.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.19 161.074)",
    d: "M237 311.6c-7.4 0-13.5-6.1-13.5-13.5V272c0-7.4 6.1-13.5 13.5-13.5s13.5 6.1 13.5 13.5v26.1c0 7.4-6.1 13.5-13.5 13.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -43.25,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 86.5,
    height: 63.5,
    transform: "matrix(.51 0 0 .51 252.66 319.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -18.3,
    y: -17.2,
    rx: 0,
    ry: 0,
    width: 36.6,
    height: 34.4,
    transform: "matrix(.51 0 0 .51 241.36 378.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#eee1ef",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -18.3,
    y: -7.55,
    rx: 0,
    ry: 0,
    width: 36.6,
    height: 15.1,
    transform: "matrix(.51 0 0 .51 241.36 383.67)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#51267c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.168 161.139)",
    d: "M150.7 441.3c-5.4 0-9.6 4.3-9.6 9.6h46.2v-9.6h-36.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -18.3,
    y: -17.2,
    rx: 0,
    ry: 0,
    width: 36.6,
    height: 34.4,
    transform: "matrix(-.51 0 0 -.51 263.91 378.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#eee1ef",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -18.3,
    y: -7.55,
    rx: 0,
    ry: 0,
    width: 36.6,
    height: 15.1,
    transform: "matrix(-.51 0 0 -.51 263.91 383.73)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#51267c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.185 161.139)",
    d: "M231.4 441.3c.1 0 .1 0 0 0 5.4 0 9.6 4.3 9.6 9.6h-46.1v-9.6h36.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -43.25,
    y: -27.15,
    rx: 0,
    ry: 0,
    width: 86.5,
    height: 54.3,
    transform: "matrix(.51 0 0 .51 252.66 298.6)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.175 161.079)",
    d: "M233.1 336.3c-3.3 0-6-2.7-6-6V279h-70.6v51.3c0 3.3-2.7 6-6 6h-2.7v78h86.5v-78h-1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fed600",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 3.4,
    transform: "matrix(.51 0 0 .51 245.39 356.8)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fed600",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.174 161.117)",
    d: "M160.5 399.9c1.2 1 2.7 1.6 4.3 1.6 3.6 0 6.6-3 6.6-6.6 0-3.6-3-6.6-6.6-6.6-.7 0-1.3.1-1.9.3.6-.9.9-1.9.9-3.1v-.4c4.1-.4 7.2-3.8 7.2-8 0-4.4-3.6-8-8-8-1.8 0-3.5.6-4.9 1.7 0-.3.1-.6.1-.9 0-3.5-2.9-6.4-6.4-6.4-1.5 0-2.9.6-4 1.5v21.9c.1 0 .2.1.3.2-.1.1-.2.2-.3.2V401c1.6 1.3 3.6 2.1 5.8 2.1 2.8 0 5.3-1.3 6.9-3.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e4177e",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 3.4,
    transform: "matrix(.51 0 0 .51 236.41 337.56)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e4177e",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.167 161.094)",
    d: "M172.5 324.8c0-3-1.7-5.6-4.2-6.9 2.1-1.6 3.4-4.2 3.4-7.1 0-5-4-9-9-9-2.4 0-4.6.9-6.2 2.5v26.1c0 2.4-1.4 4.5-3.5 5.4h.3c1.8 0 3.5-.6 4.9-1.7 0 .3-.1.6-.1.9 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-1.5-.5-2.9-1.4-4 1.8-1.5 3-3.7 3-6.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e4177e",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 2.1,
    transform: "matrix(.51 0 0 .51 262.13 370.12)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e4177e",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.186 161.128)",
    d: "M234.3 402c-.7-.6-1.6-1-2.6-1-2.2 0-4 1.8-4 4 0 .4.1.8.2 1.2-.5-.4-1.2-.6-1.9-.6h-.3c-.2-2.5-2.3-4.4-4.9-4.4-2.7 0-4.9 2.2-4.9 4.9 0 1.1.4 2.2 1 3h-.5c-2.2 0-3.9 1.8-3.9 3.9 0 .5.1.9.2 1.3h21.6V402z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#76b82a",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 3.4,
    transform: "matrix(.51 0 0 .51 259.88 337.41)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#76b82a",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.18 161.094)",
    d: "M234.3 336.3H233c-3.3 0-6-2.7-6-6v-3.9c-2.2.3-4.1 1.5-5.5 3.1-1.2-1-2.7-1.6-4.3-1.6-3.6 0-6.6 3-6.6 6.6 0 3.6 3 6.6 6.6 6.6.7 0 1.3-.1 1.9-.3-.6.9-.9 1.9-.9 3.1v.4c-4.1.4-7.2 3.8-7.2 8 0 4.4 3.6 8 8 8 1.8 0 3.5-.6 4.9-1.7 0 .3-.1.6-.1.9 0 3.5 2.9 6.4 6.4 6.4 1.5 0 2.9-.6 4-1.5v-21.9c-.1 0-.2-.1-.3-.2.1-.1.2-.2.3-.2v-5.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#4a4a49",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -0.95,
    y: -18.95,
    rx: 0,
    ry: 0,
    width: 1.9,
    height: 37.9,
    transform: "matrix(.51 0 0 .51 252.61 362.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -21.2,
    y: -6.65,
    rx: 0,
    ry: 0,
    width: 42.4,
    height: 13.3,
    transform: "matrix(.51 0 0 .51 252.63 281.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 21.2,
    ry: 3.7,
    transform: "matrix(.51 0 0 .51 252.63 284.85)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.153 161.03)",
    d: "M109.2 125.9v67.5c0 22.9 18.6 41.6 41.6 41.6h80.7c22.9 0 41.6-18.6 41.6-41.6v-67.5H109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.155 161.044)",
    d: "M109.2 163c-2.1-.4-4.4-.4-6.5 0-9 1.8-14 10.7-11.2 19.9 2.4 7.9 9.9 13.4 17.8 13.6V163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b690",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.213 161.044)",
    d: "M273 163c2.1-.4 4.4-.4 6.5 0 9 1.8 14 10.7 11.2 19.9-2.4 7.9-9.9 13.4-17.8 13.6V163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#51267c",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 154.126 160.014)",
    d: "M124.8 155.9c-1.5 3.6-2.3 7.5-2.3 11.6 0 17.1 13.8 30.9 30.9 30.9 17.1 0 30.9-13.8 30.9-30.9 0-4.1-.8-8-2.3-11.6h-57.2z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#51267c",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 30.9,
    transform: "matrix(.51 0 0 .51 270.79 245.48)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#51267c",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "M-7.55 0h15.1",
    transform: "matrix(.51 0 0 .51 212.85 243.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#51267c",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "M-7.6 0H7.6",
    transform: "matrix(.51 0 0 .51 251.61 243.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#51267c",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "M-7.55 0h15.1",
    transform: "matrix(.51 0 0 .51 290.21 243.25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#683c11",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.166 161.043)",
    d: "M145.6 165.8c0 .8-.1 1.5-.1 2.3 0 10.2 4 18.4 8.9 18.4s8.9-8.3 8.9-18.4c0-.8 0-1.6-.1-2.3h-17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.172 161.04)",
    d: "M154.1 165.8c.1 4.2 1.7 7.5 3.7 7.5s3.7-3.3 3.7-7.5h-7.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#683c11",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 8.9,
    ry: 18.4,
    transform: "matrix(.51 0 0 .51 271.32 246.77)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    rx: 3.8,
    ry: 7.8,
    transform: "matrix(.51 0 0 .51 273.01 243)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f08372",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.176 161.059)",
    d: "M165.4 216.4c4-1.4 8.1-2.5 12.3-3.4 4.1-1 8.3-1.8 12.4-2.5 4.2-.7 8.3-1.3 12.6-1.8 4.2-.5 8.4-.9 12.7-.9-4 1.4-8.2 2.4-12.3 3.4-4.1 1-8.3 1.8-12.4 2.5-4.2.7-8.3 1.4-12.5 1.8-4.3.5-8.5.9-12.8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000",
      strokeWidth: 1.15,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "m3.3-31.35-6.6 62.7",
    transform: "matrix(.51 0 0 .51 226.21 301.09)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000",
      strokeWidth: 1.15,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "m-31.75-1.6 63.5 3.2",
    transform: "matrix(.51 0 0 .51 242.55 318.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 3.9,
    transform: "matrix(.51 0 0 .51 224.52 317.26)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.164 161.074)",
    d: "m151.7 308 7.5-47.8c1.3-8-4.2-15.5-12.2-16.8-8-1.3-15.5 4.2-16.8 12.2l-7.5 47.8 29 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.16 161.073)",
    d: "M138.8 295.8c-8-1.3-13.5-8.8-12.2-16.8l3.8-24.2c1.3-8 8.8-13.5 16.8-12.2 8 1.3 13.5 8.8 12.2 16.8l-3.8 24.2c-1.3 8-8.8 13.4-16.8 12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "m13.25 12.7 3.2-20.2-29-5.2-3.9 24.8z",
    transform: "matrix(.51 0 0 .51 226.89 304.6)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.189 161.08)",
    d: "M235.8 296.4c8.1 0 14.7-6.7 14.6-14.8l-.1-24.5c0-8.1-6.7-14.7-14.8-14.6-8.1 0-14.7 6.7-14.6 14.8l.1 24.5c0 8.1 6.7 14.7 14.8 14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#b283b5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    d: "m14.8 12.55-.2-25.1-29.4.8.1 18.6z",
    transform: "matrix(.51 0 0 .51 275.4 305.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#8b688e",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -10.05,
    y: -0.65,
    rx: 0,
    ry: 0,
    width: 20.1,
    height: 1.3,
    transform: "matrix(.09 -.5 .5 .09 234.63 305.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -5.35,
    y: -18,
    rx: 0,
    ry: 0,
    width: 10.7,
    height: 36,
    transform: "matrix(.51 0 0 .51 237.36 293.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#646363",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -5.35,
    y: -18,
    rx: 0,
    ry: 0,
    width: 10.7,
    height: 36,
    transform: "matrix(.51 0 0 .51 267.93 293.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#c5c3c8",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 7.6,
    transform: "matrix(.51 0 0 .51 237.33 304.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#c5c3c8",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    r: 7.6,
    transform: "matrix(.51 0 0 .51 267.9 304.45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.165 161.079)",
    d: "m210.2 308.7-70.5 11.9c-8 1.3-15.6-4.1-17-12.1-1.3-8 4.1-15.6 12.1-17l70.5-11.9c8-1.3 15.6 4.1 17 12.1 1.3 8-4.1 15.7-12.1 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f9c5a9",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.183 161.069)",
    d: "m221.2 307.7-22-64.6c-2.6-7.7 1.5-16.1 9.2-18.7 7.7-2.6 16.1 1.5 18.7 9.2l22 64.6c2.6 7.7-1.5 16.1-9.2 18.7-7.6 2.6-16-1.5-18.7-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b691",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.188 161.067)",
    d: "M198.8 235c1.1-4.8 4.6-8.9 9.6-10.6 1.6-.5 3.2-.8 4.7-.8 6.1 0 11.9 3.9 14 10l.5 1.4h2.1l-.7-2.1c-2.3-6.8-8.7-11.3-15.9-11.3-1.8 0-3.6.3-5.4.9-4.2 1.4-7.6 4.4-9.6 8.5-.6 1.3-1.1 2.7-1.4 4h2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b691",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.191 161.101)",
    d: "m211.3 310.5 1.2-.3-1.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#f8b691",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.188 161.085)",
    d: "M224.2 291.4c-1.2-7-6.5-12.3-13.2-13.6l.8 2.2c5.3 1.5 9.5 5.9 10.5 11.7.7 4.1-.4 8.1-2.7 11.2l.8 2.3c.4-.4.7-.9 1-1.3 2.6-3.7 3.6-8.1 2.8-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#51267c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.179 161.012)",
    d: "M193.3 68.9h-4.4c-3.3 0-5.9-2.6-5.9-5.9v-4.4c0-3.3 2.6-5.9 5.9-5.9h4.4c3.3 0 5.9 2.6 5.9 5.9V63c0 3.2-2.7 5.9-5.9 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#51267c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.159 161.014)",
    d: "M273 127.6v-8.5c0-32.9-26.6-59.5-59.5-59.5h-44.8c-32.9 0-59.5 26.6-59.5 59.5v8.5H273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e5d0e4",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.167 161.011)",
    d: "M270.7 119.4c0-31.6-25.6-57.2-57.2-57.2h-6.4c-31.6 0-57.2 25.6-57.2 57.2v8.2h120.8v-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#51267c",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.51 0 0 .51 155.164 161.032)",
    d: "M228.6 120.9c-36.1 1.4-68.1 3.9-88 6.7h132.1v7.1c38.9-2.7 66-6.6 65.9-10-.2-4.4-49.5-6.1-110-3.8z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtoRikaTristes);
export default __webpack_public_path__ + "static/media/ato_rika_tristes.ad14c9d57277ed090afac8c0677c8d9a.svg";
export { ForwardRef as ReactComponent };